import { BannerListRes } from "../../types/banner";

export default function HeroBanner({ headerBannerListRes }: { headerBannerListRes: BannerListRes[] }) {
  if (!headerBannerListRes?.length) return null;

  return (
    <div
      className="w-full h-[calc(100vw*360/1080)] bg-cover bg-center bg-no-repeat flex justify-center items-center transition-all duration-300 rounded-2xl"
      style={{
        backgroundImage: `url(${headerBannerListRes[0].media.url})`,
      }}
    >
      {/* <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/10 rounded-t-2xl" /> */}

      {/* Uncomment if you want to use the logo and button
          <div className="relative z-10 flex flex-col items-center gap-3 md:gap-5">
            <div className="w-[220px] sm:w-[280px] md:w-[340px]">
              <Image 
                src={Logo} 
                alt="Guru Guru HK" 
                className="w-full h-auto"
                placeholder="blur" 
                priority
              />
            </div>
            <button className="bg-sf-lightGrayishRed text-primary font-bold px-4 py-2 md:px-6 md:py-3 rounded-xl md:rounded-2xl shadow-xl md:shadow-2xl text-sm md:text-lg hover:opacity-90 transition-all">
              Shop Now
            </button>
          </div>
          */}
    </div>
  );
}
